export const blockIconsHardwareDeviceHub = (
	<span className='material-symbols-outlined'>device_hub</span>
);
